module.exports = __webpack_public_path__ + "img/ml3096.308c4a80.png";